import { RouteConfig } from 'vue-router';

export const resetPasswordRoute: RouteConfig = {
  path: '/reset',
  name: 'reset',
  component: () => import(/* webpackChunkName: "ResetPassword" */ '@/views/startRoute/ResetPassword.vue')
};
